import IconFavorite from '../icons/IconFavorite';
import IconFavoriteBorder from '../icons/IconFavoriteBorder';

const ResultadoDetailHeader = (props) => {
  const resultado = props.resultado;

  let iniciales = '--';
  if (resultado && resultado.nombre) {
    iniciales = resultado.nombre[0];
    if (resultado.apellidos) {
      iniciales += resultado.apellidos[0];
    }
  }
  iniciales = iniciales.toLocaleUpperCase();

  return (
    <div className="w-full mb-6">
      <div className="mx-auto max-w-5xl px-4 md:px-40">
        <div className="bg-slate-900/50 rounded-lg px-6 py-6 border border-slate-700">
          <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
            {/* Avatar: siempre iniciales, sin foto por DNI */}
            <div className="w-20 h-20 rounded-full bg-ccnorte flex-shrink-0 grid place-items-center text-white text-2xl font-bold font-montserrat">
              {iniciales}
            </div>

            {/* Información del atleta */}
            <div className="flex-1 min-w-0">
              {/* Nombre */}
              <h2 className="text-2xl font-semibold text-white font-montserrat mb-2 italic">
                {resultado.nombre} {resultado.apellidos}
              </h2>

              {/* Dorsal */}
              <div className="text-sm text-slate-400 font-montserrat mb-3">
                Dorsal <strong className="text-slate-200">{resultado.dorsal}</strong>
              </div>

              {/* Club y localidad */}
              {(resultado.club || resultado.localidad) && (
                <div className="flex flex-wrap gap-2 mb-3 text-sm text-slate-400 font-montserrat">
                  {resultado.club && (
                    <span className="px-3 py-1 bg-slate-800 rounded-full capitalize">
                      {resultado.club.toLowerCase()}
                    </span>
                  )}
                  {resultado.localidad && (
                    <span className="px-3 py-1 bg-slate-800 rounded-full capitalize">
                      {resultado.localidad.toLowerCase()}
                    </span>
                  )}
                </div>
              )}

              {/* Puestos */}
              {resultado.puesto ? (
                <div className="flex flex-wrap gap-3 text-sm font-montserrat">
                  <div className="text-slate-300">
                    POS: <strong className="text-white">{resultado.puesto}</strong>
                  </div>
                  {resultado.puesto_sexo && (
                    <div className="text-slate-300">
                      {resultado.sexo === 'F' ? 'FEM' : 'MASC'}: <strong className="text-white">{resultado.puesto_sexo}</strong>
                    </div>
                  )}
                  {resultado.puesto_categoria > 0 && (
                    <div className="text-slate-300">
                      {resultado.categoria_codigo ? resultado.categoria_codigo : resultado.categoria}: <strong className="text-white">{resultado.puesto_categoria}</strong>
                    </div>
                  )}
                </div>
              ) : (
                <div className="text-sm text-slate-400 font-montserrat">
                  {resultado.categoria_codigo}
                </div>
              )}
            </div>

            {/* Botón de seguir */}
            <button
              onClick={(e) => {
                props.onClickFavorito();
                e.currentTarget.blur(); // <-- Añadir esto para quitar el hover
              }}
              className={[
                'flex-shrink-0 flex items-center gap-2 px-6 py-3 rounded-lg font-montserrat text-sm font-medium transition-colors',
                props.esFavorito
                  ? 'bg-ccnorte hover:bg-red-600 text-white'
                  : 'bg-slate-800 hover:bg-slate-700 text-white border border-slate-700'
              ].join(' ')}
            >
              {props.esFavorito ? (
                <>
                  <IconFavorite fill="white" />
                  <span>Siguiendo</span>
                </>
              ) : (
                <>
                  <IconFavoriteBorder fill="white" />
                  <span>Seguir</span>
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResultadoDetailHeader;